export default "__VITE_ASSET__CzisYkrJ__"